import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="livestream-events.hosts" defaultMessage="Hosts" />;
